import React, { ReactNode } from 'react';

interface ContentCardProps {
  title?: string | ReactNode;
  children: ReactNode;
  footer?: ReactNode;
  className?: string;
}

const ContentCard: React.FC<ContentCardProps> = ({
  title,
  children,
  footer,
  className = ''
}) => {
  return (
    <div className={`bg-white rounded-lg shadow overflow-hidden ${className}`}>
      {title && (
        <div className="px-6 py-4 border-b border-gray-200">
          {typeof title === 'string' ? (
            <h3 className="text-lg font-medium text-gray-900">{title}</h3>
          ) : (
            title
          )}
        </div>
      )}
      
      <div className="p-6">
        {children}
      </div>
      
      {footer && (
        <div className="px-6 py-4 bg-gray-50 border-t border-gray-200">
          {footer}
        </div>
      )}
    </div>
  );
};

export default ContentCard;